import React from 'react';

import Layout from 'ds/Layout';
import Spinner from 'ds/Spinner';
import { APP_BANNER_HEIGHT } from 'ds/constants';
import { selectUIState } from 'store/UI/selectors';
import { useAppSelector } from 'store/hooks';

interface Props {}

const LoadingScreen: React.FC<Props> = () => {
  const { appBannerType } = useAppSelector(selectUIState);
  return (
    <Layout
      height={appBannerType ? `calc(100vh - ${APP_BANNER_HEIGHT}px)` : '100vh'}
      justify="center"
      align="center"
      flexGrow={1}
    >
      <Spinner />
    </Layout>
  );
};

export default LoadingScreen;
